import { render, staticRenderFns } from "./clientBtnGroups.vue?vue&type=template&id=33347f03&scoped=true"
import script from "./clientBtnGroups.vue?vue&type=script&lang=js"
export * from "./clientBtnGroups.vue?vue&type=script&lang=js"
import style0 from "./clientBtnGroups.vue?vue&type=style&index=0&id=33347f03&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33347f03",
  null
  
)

export default component.exports